import * as ActionTypes from '../ActionTypes';

export const GetAtsAgreementsAction = (params) => ({
    type: ActionTypes.ATS_AGREEMENT_GET_REQUEST,
    params,
});

export const AddAtsAgreementAction = (params) => ({
    type: ActionTypes.ATS_AGREEMENT_ADD_REQUEST,
    params,
});

export const UpdateAtsAgreementAction = (params) => ({
    type: ActionTypes.ATS_AGREEMENT_UPDATE_REQUEST,
    params,
});

export const DeleteAtsAgreementAction = (params) => ({
    type: ActionTypes.ATS_AGREEMENT_DELETE_REQUEST,
    params,
});

export const UploadAgreementSignedCopyAction = (params) => ({
    type: ActionTypes.ATS_AGREEMENT_UPLOAD_SIGNED_REQUEST,
    params,
});
